import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper";

export default function OtherEditionsSlider(container) {
  const sliderContainer = container;

  let slider;
  const sliderOptions = {
    init: false,
    slideClass: "js-other-editions-slider-slide",
    wrapperClass: "js-other-editions-slider-wrapper",
    slidesPerView: "auto",
    slidesPerGroup: 2,
    // loop: true,
    pagination: {
      el: ".js-other-editions-slider-pagination",
      clickable: true
    },
    watchOverflow: true,
    on: {
      init() {
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  initSlider();

  function initLazyLoad() {
    const lazyLoad1 = new LazyLoad({
      container,
      elements_selector: ".js-lazy"
    });

    const lazyLoad2 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-bg",
      to_webp: true
    });

    const lazyLoad3 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-webp",
      to_webp: true
    });

    lazyLoad1.loadAll();
    lazyLoad2.loadAll();
    lazyLoad3.loadAll();
  }

  function initSlider() {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }
}
